import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';

if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_SENTRY_ENABLED === 'true') {
    Sentry.init({
        dsn: 'https://f1b682b00107011ccb9cf643b4551721@sentry.esafeline.com/27',
        sendDefaultPii: true,
        integrations: [
            Sentry.reactRouterV6BrowserTracingIntegration({
                useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes,
            }),
        ],
        environment: process.env.REACT_APP_ENVIRONMENT,
    });
}
